import { logger } from '@logger';
import {
  ApiV2User,
  fetchApi,
  isApiV2Error,
  setAuthToken,
  setUser,
  userResponseToUserAndToken,
} from '@utils/api/client';

type RegisterResult = 'success' | 'invalidEmail' | 'alreadyRegistered' | 'error';
export const registerUser = async (email: string, lang: string): Promise<RegisterResult> => {
  try {
    await fetchApi('/auth/register', {
      method: 'POST',
      noAuth: true,
      body: JSON.stringify({
        email,
        lang,
      }),
    });

    return 'success';
  } catch (e) {
    if (isApiV2Error(e)) {
      const status = e.response?.status;
      switch (status) {
        case 400:
          return 'invalidEmail';
        case 409:
          return 'alreadyRegistered';
      }
    }

    return 'error';
  }
};

export const confirmRegistration = async (email: string, code: string, lang?: string) => {
  try {
    const response = await fetchApi<ApiV2User>('/auth/confirm', {
      method: 'POST',
      noAuth: true,
      body: JSON.stringify({
        email,
        code,
        lang,
      }),
    });

    const { user, token } = userResponseToUserAndToken(response);

    setAuthToken(token);
    setUser(user);

    return {
      success: true as const,
    };
  } catch (e) {
    logger.error(e, '[APIV2] Account confirmation failed. %s', (e as any)?.message);

    if (isApiV2Error(e)) {
      return {
        success: false as const,
        error: e.response?.status === 400 ? 'invalidCode' : 'internalError',
      };
    }

    return {
      success: false as const,
      error: 'internalError',
    };
  }
};

export const resendCode = async (email: string, lang: string) => {
  try {
    await fetchApi('/auth/resend-code', {
      method: 'POST',
      body: JSON.stringify({
        email,
        lang,
      }),
    });

    return true;
  } catch (e) {
    return false;
  }
};
